import * as React from "react";
const SvgFiRrGarlic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-garlic_svg__a)">
      <path
        fill="#062147"
        d="M16 5.466V3.5c-.04-2.494-2.18-3.765-4.5-3.5A3.506 3.506 0 0 0 8 3.5v1.966C6.251 6.681.333 11.278.006 17.934A4.726 4.726 0 0 0 4.428 23a4.97 4.97 0 0 0 3.33-1.417 5 5 0 0 0 8.508.03 4.543 4.543 0 0 0 7.728-3.679C23.667 11.278 17.75 6.681 16 5.466M10 3.5A1.5 1.5 0 0 1 11.5 2h1A1.5 1.5 0 0 1 14 3.5v2.14a6 6 0 0 0-.85 1.74 1.93 1.93 0 0 0-2.309.007 5.7 5.7 0 0 0-.84-1.757zm-3 15A2.52 2.52 0 0 1 4.458 21a2.685 2.685 0 0 1-2.453-2.968c.26-5.26 4.84-9.209 6.721-10.617.308.756.496 1.555.557 2.37A20.8 20.8 0 0 0 7 18.5m6.927 2.8a2.98 2.98 0 0 1-2.49.646c-4.872-1.214-1.358-9.859.563-12.95 1.8 2.888 4.61 9.881 1.924 12.304zm7.274-1.06c-1.314 1.6-4.294.428-4.195-1.743-.12-3.038-.9-6.014-2.288-8.72a7 7 0 0 1 .557-2.366c1.878 1.41 6.461 5.36 6.725 10.62a3.06 3.06 0 0 1-.8 2.212z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-garlic_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGarlic;
